var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgConfirmWithMark(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 5.469v17.187C18 23.951 16.993 25 15.75 25H2.25C1.007 25 0 23.95 0 22.656V5.47c0-1.295 1.007-2.344 2.25-2.344H6C6 1.402 7.346 0 9 0s3 1.402 3 3.125h3.75c1.243 0 2.25 1.05 2.25 2.344zM9 1.953c-.621 0-1.125.525-1.125 1.172 0 .647.504 1.172 1.125 1.172s1.125-.525 1.125-1.172c0-.647-.504-1.172-1.125-1.172zm4.5 5.567v-.977a.3.3 0 00-.082-.207.276.276 0 00-.2-.086H4.782a.276.276 0 00-.199.086.3.3 0 00-.082.207v.977a.3.3 0 00.082.207.276.276 0 00.2.085h8.437c.074 0 .146-.03.199-.085a.3.3 0 00.082-.207z",
    fill: "#2A848E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.512 5.208a.818.818 0 00-1.157.068l-5.457 6.137-2.511-2.344a.823.823 0 00-1.258 1.043l2.74 4.332a1.343 1.343 0 002.247.033l5.53-8.2a.82.82 0 00-.134-1.068",
    fill: "#FFD31A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmWithMark);
export default ForwardRef;